module.exports = __webpack_public_path__ + "img/miniCode.02d52d3a.png";